module.exports = __webpack_public_path__ + "img/qxqp.d76296d9.svg";